  document.addEventListener("DOMContentLoaded", () => {
    // Splash screen
    const splash = document.querySelector(".splash");
    splash.addEventListener("animationend", () => {
      splash.style.display = "none";
    });
  });

  document.addEventListener('mouseover', function (e) {
    var wrapper = e.target.closest('.card-wrapper');
    if (!wrapper) return;
    var video = wrapper.querySelector('video.card-video-hover');
    if (!video) return;
    video.play();
  });
  document.addEventListener('mouseout', function (e) {
    var wrapper = e.target.closest('.card-wrapper');
    if (!wrapper) return;
    if (wrapper.contains(e.relatedTarget)) return;
    var video = wrapper.querySelector('video.card-video-hover');
    if (!video) return;
    video.pause();
  });

// ─── Infinite Slideshow ───────────────────────────────────────────────────────
// Extends the built-in SlideshowComponent from global.js.
// Uses a clone-buffer technique: one clone of the last slide is prepended and
// one clone of the first slide is appended so the user can scroll endlessly in
// either direction. After each scroll-snap settles we silently teleport back to
// the matching real slide. Autoplay always advances forward; the teleport handles
// the wrap. Works for both swipe/drag and auto-rotate.
class InfiniteSlideshow extends SlideshowComponent {
  constructor() {
    super();
    // Flag — cloning not yet done
    this._infiniteReady = false;
  }

  connectedCallback() {
    // Wait until the browser has laid out the element (so clientWidth is non-zero)
    requestAnimationFrame(() => this._initInfinite());
  }

  // ── Bootstrap ──────────────────────────────────────────────────────────────
  _initInfinite() {
    this.slider = this.querySelector('[id^="Slider-"]');
    if (!this.slider) return;

    // Collect only the *real* slides (not clones from a previous init)
    this._realSlides = Array.from(
      this.slider.querySelectorAll('.slideshow__slide:not([data-clone])')
    );
    this.realCount = this._realSlides.length;

    // Single slide or no slides → nothing to loop; let the existing code handle display
    if (this.realCount < 2) {
      this._infiniteReady = false;
      return;
    }

    // Remove any stale clones from a previous init (e.g. theme-editor re-render)
    this.slider.querySelectorAll('[data-clone]').forEach(el => el.remove());

    // Clone last real slide → prepend (so scrolling left past slide 1 shows it)
    const cloneBefore = this._realSlides[this.realCount - 1].cloneNode(true);
    cloneBefore.setAttribute('aria-hidden', 'true');
    cloneBefore.setAttribute('data-clone', 'before');
    // Remove IDs to avoid duplicates
    cloneBefore.removeAttribute('id');
    cloneBefore.querySelectorAll('[id]').forEach(el => el.removeAttribute('id'));
    this.slider.prepend(cloneBefore);

    // Clone first real slide → append (so scrolling right past last slide shows it)
    const cloneAfter = this._realSlides[0].cloneNode(true);
    cloneAfter.setAttribute('aria-hidden', 'true');
    cloneAfter.setAttribute('data-clone', 'after');
    cloneAfter.removeAttribute('id');
    cloneAfter.querySelectorAll('[id]').forEach(el => el.removeAttribute('id'));
    this.slider.append(cloneAfter);

    this._infiniteReady = true;

    // Jump (no animation) to the first real slide (index 1 in the new DOM)
    this._jumpToReal(0);

    // Listen for scroll-snap settle to run the teleport logic
    this._attachScrollEndListener();
  }

  // ── Silent jump to a real slide by 0-based real index ─────────────────────
  _jumpToReal(realIndex, smooth = false) {
    if (!this.slider) return;
    // In the DOM: [clone-before, real-0, real-1, …, real-N-1, clone-after]
    // real-0 is at DOM position 1 → slide-width * 1
    const slideWidth = this.slider.clientWidth;
    const targetLeft = slideWidth * (realIndex + 1);
    if (smooth) {
      this.slider.scrollTo({ left: targetLeft, behavior: 'smooth' });
    } else {
      // Instant — suppress scroll-behavior temporarily
      const prev = this.slider.style.scrollBehavior;
      this.slider.style.scrollBehavior = 'auto';
      this.slider.scrollLeft = targetLeft;
      this.slider.style.scrollBehavior = prev;
    }
  }

  // ── Get current real index from scroll position ────────────────────────────
  _currentRealIndex() {
    const slideWidth = this.slider.clientWidth || 1;
    // DOM position of visible slide (0-based including clones)
    const domIndex = Math.round(this.slider.scrollLeft / slideWidth);
    // domIndex 0 → before-clone (= real last), domIndex 1..N → real 0..N-1, domIndex N+1 → after-clone (= real first)
    // Map to real index
    if (domIndex === 0) return this.realCount - 1;
    if (domIndex > this.realCount) return 0;
    return domIndex - 1; // 0-based real index
  }

  // ── Teleport after scroll settles ─────────────────────────────────────────
  _onScrollEnd() {
    if (!this._infiniteReady) return;
    const slideWidth = this.slider.clientWidth || 1;
    const scrollLeft = this.slider.scrollLeft;
    const total = this.realCount + 2; // includes both clones

    // On the before-clone → jump to last real slide
    if (scrollLeft < slideWidth * 0.5) {
      this._jumpToReal(this.realCount - 1);
      this._syncDots(this.realCount - 1);
      return;
    }

    // On the after-clone → jump to first real slide
    if (scrollLeft >= slideWidth * (total - 1) - slideWidth * 0.5) {
      this._jumpToReal(0);
      this._syncDots(0);
      return;
    }

    // Normal real slide — just sync dots
    this._syncDots(this._currentRealIndex());
  }

  // ── Attach scrollend (with debounce fallback for Safari) ───────────────────
  _attachScrollEndListener() {
    if ('onscrollend' in window) {
      this.slider.addEventListener('scrollend', () => this._onScrollEnd());
    } else {
      // Fallback: debounce on scroll
      let timer;
      this.slider.addEventListener('scroll', () => {
        clearTimeout(timer);
        timer = setTimeout(() => this._onScrollEnd(), 80);
      });
    }
  }

  // ── Override: update() fires on EVERY scroll tick ─────────────────────────
  // The parent SlideshowComponent.update() calculates currentPage as
  //   Math.round(scrollLeft / sliderItemOffset) + 1
  // But because the before-clone adds one extra slideWidth of offset at the
  // start of the track, every real-slide index comes out +1 too high.
  // That causes the wrong dot to flash briefly before _onScrollEnd corrects it.
  // We intercept update() and re-map the index immediately — all synchronously,
  // so the browser never paints an incorrect dot state.
  update() {
    if (!this._infiniteReady) {
      super.update();
      return;
    }

    const slideWidth = this.slider.clientWidth || 1;
    const domIndex   = Math.round(this.slider.scrollLeft / slideWidth);

    // Map DOM index (includes clone positions) → 0-based real index
    let realIndex;
    if (domIndex === 0)                  realIndex = this.realCount - 1; // on before-clone
    else if (domIndex > this.realCount)  realIndex = 0;                  // on after-clone
    else                                 realIndex = domIndex - 1;       // on real slide

    // Keep currentPage consistent for any inherited logic that reads it
    this.currentPage = realIndex + 1;

    this._syncDots(realIndex);
  }

  // ── Sync dot indicators to the correct real slide ─────────────────────────
  _syncDots(realIndex) {
    const dots = Array.from(this.querySelectorAll('.slider-counter__link'));
    if (!dots.length) return;
    dots.forEach((dot, i) => {
      dot.classList.toggle('slider-counter__link--active', i === realIndex);
      if (i === realIndex) {
        dot.setAttribute('aria-current', 'true');
      } else {
        dot.removeAttribute('aria-current');
      }
    });

    // Update counter display if present
    const currentEl = this.querySelector('.slider-counter--current');
    const totalEl   = this.querySelector('.slider-counter--total');
    if (currentEl) currentEl.textContent = realIndex + 1;
    if (totalEl)   totalEl.textContent   = this.realCount;
  }

  // ── Override: autoplay always steps forward; teleport handles the wrap ─────
  autoRotateSlides() {
    if (!this._infiniteReady) {
      // Fall back to original behaviour if only 1 slide
      super.autoRotateSlides();
      return;
    }
    const slideWidth = this.slider.clientWidth;
    this.slider.scrollTo({
      left: this.slider.scrollLeft + slideWidth,
      behavior: 'smooth',
    });
  }

  // ── Override: button clicks loop correctly ─────────────────────────────────
  onButtonClick(event) {
    if (!this._infiniteReady) {
      super.onButtonClick(event);
      return;
    }
    event.preventDefault();
    const slideWidth = this.slider.clientWidth;
    const direction  = event.currentTarget.name === 'next' ? 1 : -1;
    this.slider.scrollTo({
      left: this.slider.scrollLeft + direction * slideWidth,
      behavior: 'smooth',
    });
  }
}

customElements.define('infinite-slideshow', InfiniteSlideshow);